import UIkit from 'uikit'

export class NotificationService {
  static notify (message: string) {
    UIkit.notification({
      message,
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}
